import { createSlice } from "@reduxjs/toolkit";
import {
  getDashboardConfiguration,
  getDashboardListDetails,
  getAllRolesByOrg,
  getAllUsersByOrg,
  getDashboardFilters
} from "api/dashboard";
import { bankVerification } from "api/dashboardDetail";
import { deleteWorkflowInfoById } from "api/formDisplay";
import { getRolesInfo } from "api/user";
import { userAuth } from "api/userAuth";

const initialState = {
  dashboardConfig: {},
  loading: false,
  dashboardDataLoading : false,
  dashboardFields: [],
  dashboardFieldsCheckboxList: [],
  checkboxList: {},
  selectedFilterCheckboxList: {},
  dateFilterCheckboxList: {},
  filterDropdownList: {},
  workflowId: "",
  dashboardListingData: {},
  tableListingData: [],
  tableListingAllData: [],
  internalPocUsers: [],
  tableCount: 0,
  workflowDelete: "",
  workflow_modules: {},
  current_module: {},
  activeSelectedTab: 0,
  loadingAppplicantDataToDownload: false,
  dynamicConfigId: '',
  rolesInfo: {},
  sidebarLoading: false,
  sidebarStructure: {},
  csvBulkresponse:false,
  rowPerPage:10,
  checkRowsChange:false,
  numberOfRecords:10,
  headerLoading: false,
  isModalOpen: false,
  selectedTableSortOptions : {},
  verificationWorkflows : [],
  verificationResponse : null,
  bulkVerifiedResponse: false,
  dashboardFilter: {},
  defaultFilter: {},
  updatedDefaultFilter: {},
  prepopulateDefaultFilter: {},
};

export const dashboardReducer = createSlice({
  name: "dashboardReducer",
  initialState,
  reducers: {
    setDashboardConfig: (state, action) => {
      state.dashboardConfig = action.payload;
    },
    setDashboardState: (state, action) => {
      state[action.payload.key] = action.payload.value;
    },
    setFilterCheckboxList: (state, action) => {
      state.selectedFilterCheckboxList[action.payload.type] = action.payload.value[action.payload.type];
    },
    setDashboardCheckboxList: (state, action) => {
      state.checkboxList[action.payload.key] = action.payload.value;
    },
    clearAllFilterCheckBox: (state, action) => {
      state.selectedFilterCheckboxList = {};
      state.selectedTableSortOptions = {};
    },
    setAllDashboardCkeckboxList: (state, action) => {
      state.checkboxList = action.payload;
    },
    setAllFilterCheckBoxList: (state, action) => {
      state.filterDropdownList = action.payload;
    },
    setActiveSelectedTab: (state, action) => {
      state.activeSelectedTab = action.payload;
    },
    setloadingAppplicantDataToDownload: (state, action) => {
      state.loadingAppplicantDataToDownload = action.payload;
    },
    setDynamicConfigID: (state, action) => {
      state.dynamicConfigId = action.payload
    },
    setSidebarLoading: (state, action) => {
      state.sidebarLoading = action.payload;
    },
    setcsvBulkresponse: (state, action) => {
      state.csvBulkresponse = action.payload;
    },
    setRowPerPage:(state,action) => {
      state.rowPerPage = action.payload;
    },
    setRowsChange:(state,action) => {
      state.checkRowsChange = action.payload;
    },
    setNumberOfRecords:(state,action) => {
      state.numberOfRecords = action.payload;
    },
    setHeaderLoading: (state, action) => {
      state.headerLoading = action.payload;
    },
    setisModalOpen :(state, action) => {
      state.isModalOpen = action.payload;
    },
    setSelectedTableSortOptions : (state, action) => {
      state.selectedTableSortOptions = action.payload;
    },
    setVerificationWorkflows: (state, action) => {
      let oldWorkflows = state.verificationWorkflows
      state.verificationWorkflows = [...oldWorkflows, ...action.payload]
    },
    clearVerificationWorkflows: (state, action) => {
      if(!action.payload){
       state.verificationWorkflows = [];
      } else {
        let oldWorkflows = state.verificationWorkflows;
        let workflows = oldWorkflows.filter((workflow) => workflow !== action.payload)
        state.verificationWorkflows = [...workflows]
      }
    },
    setVerificationLoading: (state, action) => {
      state.verificationResponse = action.payload
    },
    setBulkVerifiedResponse: (state, action) => {
      state.bulkVerifiedResponse = action.payload
    },
    setDefaultFilter: (state, action) => {
      state.defaultFilter = action.payload;
    },
    setUpdatedDefaultFilter: (state, action) => {
      state.updatedDefaultFilter = action?.payload;
    },
    setPrepopulateDefaultFilter: (state, action) => {
      state.selectedFilterCheckboxList = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardConfiguration.pending, (state) => {
        state.loading = true;
        state.headerLoading = true;
      })
      .addCase(getDashboardConfiguration.fulfilled, (state, action) => {
        state.loading = false;
        state.headerLoading = false;
        state.dashboardConfig = action.payload;
        state.error = "success";
      })
      .addCase(getDashboardConfiguration.rejected, (state) => {
        state.loading = false;
        state.headerLoading = false
        state.error = "rejected";
      });
    builder
      .addCase(getDashboardFilters.pending, (state) => {
        // state.loading = true;
        state.headerLoading = true;
      })
      .addCase(getDashboardFilters.fulfilled, (state, action) => {
        // state.loading = false;
        state.headerLoading = false;
        state.dashboardFilter = action.payload;
        state.error = "success";
      })
      .addCase(getDashboardFilters.rejected, (state) => {
        // state.loading = false;
        state.headerLoading = false
        state.error = "rejected";
      });
    builder
      .addCase(getDashboardListDetails.pending, (state) => {
        state.loading = true;
        state.dashboardDataLoading = true
      })
      .addCase(getDashboardListDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardDataLoading = false
        state.dashboardConfig = action?.payload?.configurationInfo;
        state.tableListingData = action?.payload?.table_listing_data;
        state.filterDropdownList = action?.payload?.filter_dropdown_list;
        state.tableCount = action.payload?.table_count;
        state.error = "success";
      })
      .addCase(getDashboardListDetails.rejected, (state) => {
        state.loading = false;
        state.dashboardDataLoading = false;
        state.error = "rejected";
      });
    builder
      .addCase(deleteWorkflowInfoById.pending, (state) => {
        state.workflowDelete = "";
      })
      .addCase(deleteWorkflowInfoById.fulfilled, (state) => {
        state.workflowDelete = "success";
      })
      .addCase(deleteWorkflowInfoById.rejected, (state) => {
        state.workflowDelete = "";
      })
      .addCase(bankVerification.pending, (state) => {
        state.loading = true;
      })
      .addCase(bankVerification.fulfilled, (state) => {
        state.loading = false
      })
      .addCase(bankVerification.rejected, (state) => {
        state.loading = false
        state.error = "rejected";
      });

    builder
      .addCase(getRolesInfo.pending, (state) => {
        state.sidebarLoading = true;
      })
      .addCase(getRolesInfo.fulfilled, (state, action) => {
        state.rolesInfo = action?.payload
        state.error = "success"
        state.sidebarLoading = false
      })
      .addCase(getRolesInfo.rejected, (state) => {
        state.loading = false
        state.error = "rejected"
        state.sidebarLoading = false
      });
    builder
      .addCase(getAllUsersByOrg.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllUsersByOrg.fulfilled, (state, action) => {
        state.loading = false;
        state.allUsers = action.payload;
        let internal_poc_users = [];
        let all_user_poc = [];
        action.payload.length && action.payload?.forEach((user) => {
          if (user?.role?.includes(state.dashboardConfig?.assign_to_roles)) {
            internal_poc_users.push({
              id: "assign_poc",
              label: user?.profile?.first_name + " " + user?.profile?.last_name,
              value: user._id,
              email: user?.email_id,
              mobile_number: user?.mobile_number
            });
          }
        });
        state.internalPocUsers = internal_poc_users;
        
        action.payload.length && action.payload?.forEach((user) => {
          // if (user?.role?.includes(state.dashboardConfig?.assign_to_roles)) {
            all_user_poc.push({
              id: "assign_poc",
              label: user?.profile?.first_name + " " + user?.profile?.last_name,
              value: user._id,
              email: user?.email_id,
              mobile_number: user?.mobile_number
            });
          // }
        });
        state.all_users = all_user_poc;
      })
      .addCase(getAllUsersByOrg.rejected, (state) => {
        state.allUsers = [];
      });
    builder
      .addCase(getAllRolesByOrg.pending, (state) => {
      })
      .addCase(getAllRolesByOrg.fulfilled, (state, action) => {
        state.allRoles = action.payload;
      })
      .addCase(getAllRolesByOrg.rejected, (state) => {
        state.allRoles = [];
      });
    builder.addCase(userAuth.fulfilled, (state, action) => {
      const userAuthInfo = { ...state.userAuthInfo, ...action.payload };
      const modules = {};
      userAuthInfo?.modules && userAuthInfo?.modules.forEach((ele) => {
        modules[ele.module_name] = ele.module_id;
        if (ele.is_default || ele.module_name === "low_code_dashboard") {
          state.current_module = {
            id: ele.module_id,
            name: ele.module_name,
          };
        }
        if (ele?.module_name === "low_code_detail_view") {
          state.current_module.detail_view_module_id = ele.module_id;
        }
      });
      state.workflow_modules = modules;
    });
  },
});

// Action creators are generated for each case reducer function
export const {
  setDashboardConfig,
  setDashboardState,
  setDashboardCheckboxList,
  setFilterCheckboxList,
  clearAllFilterCheckBox,
  setDateFilterCheckboxList,
  setAllDashboardCkeckboxList,
  setAllFilterCheckBoxList,
  setActiveSelectedTab,
  setSidebarLoading,
  setloadingAppplicantDataToDownload,setDynamicConfigID,
  setcsvBulkresponse,
  setRowPerPage,
  setRowsChange,
  setNumberOfRecords,
  setHeaderLoading,
  setisModalOpen,
  setSelectedTableSortOptions,
  setVerificationWorkflows,
  clearVerificationWorkflows,
  setVerificationLoading,
  setBulkVerifiedResponse,
  setDefaultFilter,
  setUpdatedDefaultFilter,
  setPrepopulateDefaultFilter,
  setLoading,

} = dashboardReducer.actions;

export default dashboardReducer.reducer;
